import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../common/AlertModal";
import { useState, useEffect, useMemo } from "react";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import PayPalButton from "../../services/PayPalButton";
import EventSupport from "./EventSupport";
import { sendEmail } from "../../services/EmailSender";
import UtilMethods from "../../util/UtilMethods";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { useAuth } from "../../auth/AuthContext";
import { PAYMENT_METHODS, STATUS_OPTIONS } from "../common/Constants";

const otpVerified = true;
const validationErrors = {};

const renderTextField = (
  label,
  name,
  required,
  type,
  disabled,
  value = "",
  onChange = () => {},
  placeholder = ""
) => (
  <Form.Group>
    <Form.Label>
      {label} {required && <span style={{ color: "red" }}>*</span>}
    </Form.Label>
    <Form.Control
      type={type}
      name={name}
      required={required}
      disabled={disabled}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </Form.Group>
);

const PaymentAccordion = ({
  groupInfo,
  eventData,
  setGroupInfo,
  setOriginalGroupInfo,
  onAccordionHeaderClick,
  handleInputChange,
  handleSaveClick,
  isSaveDisabled,
  isAdmin,
  isValidData,
}) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  const { userType } = useAuth();

  const handleCloseSuccessModal = () => {
    console.log("Proceeding to Waiver Form after successful registration...");
    setShowSuccessModal(false);
    setSuccessMessage("");
    if (groupInfo && groupInfo.registrationID) {
      const baseUrl = process.env.REACT_APP_URL || window.location.origin;
      const linkW = `${baseUrl}/waiver-form?registrationID=${groupInfo.registrationID}&retreatID=${groupInfo.retreatID}`;
      console.log("Navigating to Waiver Form:", linkW);
      window.location.href = linkW;
    }
  };

  const handleCloseModal = () => {
    setShowErrorModal(false);
    setError("");
  };

  const handleCopyReference = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(paymentReference)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
          fallbackCopyTextToClipboard(paymentReference);
        });
    } else {
      fallbackCopyTextToClipboard(paymentReference);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      // Using deprecated execCommand as fallback for older browsers
      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } else {
        console.error("Fallback: Failed to copy text");
      }
    } catch (err) {
      console.error("Fallback: Unable to copy", err);
    }
    document.body.removeChild(textArea);
  };

  const paymentMethods =
    eventData &&
    eventData.paymentMethods &&
    eventData.paymentMethods.trim().length > 0
      ? eventData.paymentMethods.split(", ").map((method) => ({
          key: method.trim(),
          value: method.trim(),
        }))
      : PAYMENT_METHODS;
  // console.log("isAdmin:", isAdmin);
  // console.log("isSaveDisabled:", isSaveDisabled());

  useEffect(() => {
    if (
      paymentMethods.length === 1 &&
      groupInfo.paymentMethod !== paymentMethods[0].key
    ) {
      // Create a shallow copy to avoid mutating readonly state
      setGroupInfo((prev) => ({
        ...prev,
        paymentMethod: paymentMethods[0].key,
      }));
    }
    // eslint-disable-next-line
  }, [paymentMethods, groupInfo, setGroupInfo]);

  const handleSuccess = async (details) => {
    //console.log("✅ Payment success:", details);
    let paidAmount = Number.isFinite(Number(groupInfo.paidAmount))
      ? Number(groupInfo.paidAmount)
      : 0;
    let paymentHistory = [];
    try {
      // Try to parse existing JSON array
      if (groupInfo.paymentInfo) {
        paymentHistory = JSON.parse(groupInfo.paymentInfo);
        if (!Array.isArray(paymentHistory)) {
          paymentHistory = [paymentHistory];
        }
      }
    } catch (err) {
      // Fallback: if old data is not valid JSON
      paymentHistory = [];
    }
    paymentHistory.push(details); // Add new payment details
    const paymentValue = Number(details?.purchase_units?.[0]?.amount?.value);
    const updatedGroupInfo = {
      ...groupInfo,
      paymentInfo: JSON.stringify(paymentHistory), // store as valid JSON array
      paidAmount: (
        paidAmount + (Number.isFinite(paymentValue) ? paymentValue : 0)
      ).toFixed(2),
      status: "Paid",
    };
    console.log("Updated Group Info: Amount", updatedGroupInfo.paidAmount);
    // Update state
    setGroupInfo(updatedGroupInfo);
    setOriginalGroupInfo({ ...updatedGroupInfo });
    //handleSaveClick("PAYMENT2");
    {
      /**> */
    }
    try {
      console.log(
        "Saving group data after payment success...updatedGroupInfo.status:",
        updatedGroupInfo.status
      );
      const response = await EventSupport.saveGroupData(updatedGroupInfo);
      console.log("Registration response.error:", response.error);

      if (!response.error && response.registrationID) {
        console.log(
          "Registration successful!",
          response.message + " With ID: " + response.registrationID
        );

        let baseMessage =
          response.message +
          " with Registration ID: " +
          (response.registrationID || "N/A");

        let waitListNote =
          updatedGroupInfo.status === "Wait List" &&
          !updatedGroupInfo.registrationID
            ? " | The status is WAIT LIST. Contact retreat@graceanointing.org for confirmation."
            : "";

        // Send email notification
        const emailData = {
          fullName:
            updatedGroupInfo.firstName + " " + updatedGroupInfo.lastName,
          email: updatedGroupInfo.email,
          phone: updatedGroupInfo.phone,
          amount: updatedGroupInfo.amount,
          paymentMethod: updatedGroupInfo.paymentMethod,
          status: updatedGroupInfo.status,
          isApproved:
            updatedGroupInfo.status === "Approved" ||
            updatedGroupInfo.status === "Confirmed"
              ? "Yes"
              : "No",
          groupMembers:
            UtilMethods.formatGroupMembers(updatedGroupInfo.groupMembers) + "",
          registrationID: response.registrationID,
          retreatName: eventData.name || "Retreat",
          paymentOptions: eventData.paymentOptions,
          retreatEmail: eventData.retreatEmail,
        };
        const emailResponse = await sendEmail(
          emailData,
          "retreat",
          "service_retreat"
        );
        if (emailResponse.success) {
          console.log("Email sent successfully:", emailResponse);
          baseMessage =
            baseMessage + ", And Email confirmation sent to " + groupInfo.email;
        }

        setSuccessMessage(baseMessage + waitListNote);
        setShowSuccessModal(true);

        //alert(baseMessage + waitListNote);
      }
    } catch (err) {
      console.error("❌ Error during registration or email:", err);
      setError(
        "❌ Registration error:Something went wrong during registration : " +
          err?.message
      );
      //alert("Something went wrong during registration.");
      setShowErrorModal(true);
    }
  };

  const handleError = (error) => {
    console.error("❌ Payment error:", error);
    setError(
      error?.message || "❌ Payment error:Something went wrong during payment."
    );
    setShowErrorModal(true);
    //alert("Something went wrong during registration.", error);
  };

  const paymentMethod = groupInfo?.paymentMethod || "";
  const amountNumber = Number(groupInfo.amount - groupInfo.paidAmount);
  const hasAmount = amountNumber > 0;
  const hasClientId = !!eventData?.paypal_clientID;

  const paymentReference = useMemo(() => {
    if (!groupInfo) return "no-ref";

    let paymentReference = [
      groupInfo.retreatID ? `ID:${groupInfo.retreatID}` : "",
      groupInfo.registrationID ? `-${groupInfo.registrationID},` : "",
      groupInfo.firstName && groupInfo.lastName
        ? `Name: ${groupInfo.firstName} ${groupInfo.lastName}`
        : "",
      groupInfo.phone ? `,Phone: ${groupInfo.phone}` : "",
    ];

    return paymentReference.join("");
  }, [
    groupInfo?.retreatID,
    groupInfo?.registrationID,
    groupInfo?.firstName,
    groupInfo?.lastName,
    groupInfo?.phone,
  ]);

  useEffect(() => {
    if (groupInfo && paymentReference !== groupInfo.paymentReference) {
      setGroupInfo((prev) => ({
        ...prev,
        paymentReference: paymentReference,
      }));
    }
    // eslint-disable-next-line
  }, [paymentReference]);

  const shouldShowPayPal =
    paymentMethod === "PayPal" && hasAmount && hasClientId;
  const shouldShowZelle = paymentMethod === "Zelle" && hasAmount;
  const invalidMembersCount = Object.keys(validationErrors).filter(
    (key) => Object.keys(validationErrors[key]).length > 0
  ).length;

  const amountFormatted = isNaN(amountNumber)
    ? "0.00"
    : amountNumber.toFixed(2);

  return (
    <Accordion.Item eventKey="3">
      <Accordion.Header onClick={onAccordionHeaderClick}>
        <h4>
          <FontAwesomeIcon
            icon={faCreditCard}
            className="me-2"
            aria-hidden="true"
          />
          Payment | Mode: {groupInfo.paymentMethod} | Pending Amount:{" "}
          {amountFormatted}
          {invalidMembersCount > 0 && (
            <Badge bg="danger" className="ms-2">
              {invalidMembersCount} Invalid Members
            </Badge>
          )}
        </h4>
      </Accordion.Header>
      <Accordion.Body>
        <div>
          {/* Payment Info Fields */}
          <Row className="mb-3">
            <Col xs={12} md={4} className="mb-2">
              <Form.Group>
                <Form.Label>
                  Payment Method <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Select
                  value={groupInfo.paymentMethod || ""}
                  required
                  disabled={userType === "G" && !otpVerified}
                  isInvalid={!!validationErrors.paymentMethod}
                  onChange={(e) =>
                    handleInputChange("paymentMethod", e.target.value)
                  }
                >
                  
                  {paymentMethods.map((method) => (
                    method.key === "Stripe" && groupInfo.country !== 'CA' ? null : (
                      <option key={method.key} value={method.key}>
                        {method.value}
                      </option>
                    )
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {validationErrors.paymentMethod}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} md={4} className="mb-2">
              {renderTextField(
                "Amount $",
                "amount",
                true,
                "number",
                true,
                groupInfo.amount || "",
                (e) => handleInputChange("amount", e.target.value)
              )}
            </Col>
            <Col xs={12} md={4} className="mb-2">
              <span
                data-toggle="tooltip"
                title="Payment received in the bank will be updated within 2 days"
                style={{ cursor: "pointer" }}
              >
                {renderTextField(
                  "Paid Amount $",
                  "paidAmount",
                  false,
                  "number",
                  !isAdmin,
                  groupInfo.paidAmount || "0.00",
                  (e) => handleInputChange("paidAmount", e.target.value),
                  "0.00"
                )}
              </span>
            </Col>
          </Row>
          {/* Admin Fields */}
          {isAdmin && (
            <Row className="mb-3">
              <Col xs={12} md={6} className="mb-2">
                {renderTextField(
                  "Payment Info",
                  "paymentInfo",
                  true,
                  "text",
                  !isAdmin,
                  groupInfo.paymentInfo || "",
                  (e) => handleInputChange("paymentInfo", e.target.value),
                  "Payment Info"
                )}
              </Col>
              <Col xs={12} md={6} className="mb-2">
                {renderTextField(
                  "Refund Amount $",
                  "refundAmount",
                  false,
                  "number",
                  !isAdmin,
                  groupInfo.refundAmount || "",
                  (e) => handleInputChange("refundAmount", e.target.value),
                  "Refund Amount"
                )}
              </Col>
              <Col xs={12} md={6} className="mb-2">
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={groupInfo.status || ""}
                    disabled={!isAdmin}
                    onChange={(e) =>
                      handleInputChange("status", e.target.value)
                    }
                  >
                    {STATUS_OPTIONS.map((status) => (
                      <option key={status.key} value={status.key}>
                        {status.value}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          )}
        </div>
        {/* Save Button before proceeding with payment Add all validations before save
        <div style={{ marginTop: "20px", marginBottom: "10px" }}>
          <button
            type="button"
            className="btn btn-primary"
            disabled={isSaveDisabled()}
            onClick={(e) => {
              console.log("Save button clicked in PaymentAccordion");
              if (!isSaveDisabled()) {
                handleSaveClick("PAYMENT"); // Pass "PAYMENT" mode to indicate save from PaymentAccordion
              }
            }}
          >
            Save Before Proceeding with Payment
          </button>
        </div>*/}
        {/* PayPal Button */}
        <div>
          {groupInfo.status !== "Cancelled" &&
          groupInfo.status !== "Wait List" &&
          hasAmount &&
          groupInfo.registrationID &&
          groupInfo.registrationID !== "" ? (
            <div>
              {/*Pending Amount: <strong>${amountFormatted}</strong>*/}
              {shouldShowPayPal ? (
                <PayPalButton
                  amount={amountFormatted}
                  clientID={eventData.paypal_clientID}
                  eventData={eventData}
                  registrationID={groupInfo.registrationID}
                  payerEmail={groupInfo.email}
                  onSuccess={handleSuccess}
                  onError={handleError}
                  isValidData={isValidData}
                />
              ) : shouldShowZelle ? (
                <div style={{ marginTop: "20px" }}>
                  <h5>Zelle Payment Instructions</h5>
                  <Row>
                    <Col xs={12} md={8} className="mb-3">
                      <p>
                        <strong>Reference:</strong> {paymentReference}
                        <FontAwesomeIcon
                          icon={faCopy}
                          className="ms-2"
                          style={{
                            cursor: "pointer",
                            color: copied ? "green" : "#ce9c52ff",
                          }}
                          onClick={handleCopyReference}
                          title={copied ? "Copied!" : "Copy to clipboard"}
                        />
                        {copied && (
                          <span className="ms-2 text-success">Copied!</span>
                        )}
                        <br />
                        Please send the pending amount of{" "}
                        <strong>${amountFormatted}</strong> via Zelle to:{" "}
                        <strong>
                          {eventData.zelle_email || "info@graceanointing.org"}
                        </strong>
                        <br />
                        {
                          "Copy the above reference in the payment details/memo for easy identification. "
                        }
                        <br /> <br />
                      </p>
                    </Col>

                    {eventData.zelle_QR_Image && (
                      <Col xs={12} md={4} className="mb-3 text-center">
                        <p>🔗 QR code for quick access to Zelle.</p>

                        <a
                          href={eventData.zelle_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${process.env.PUBLIC_URL}/images/${eventData.zelle_QR_Image}`}
                            alt="🔗Zelle QR Code/Link"
                            style={{
                              maxWidth: "150px",
                              width: "100%",
                              height: "auto",
                              border: "1px solid #c63434ff",
                              borderRadius: "5px",
                            }}
                          />
                        </a>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col xs={12} md={8} className="mb-1 ">
                   
                      Please click the “Submit Registration” button and ensure that the payment is completed within two weeks.👉
      
                    </Col>
                    <Col xs={12} md={4} className="mb-1">
                      <div style={{ marginTop: "15px" }}>
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={
                            typeof isSaveDisabled === "function"
                              ? isSaveDisabled()
                              : !!isSaveDisabled
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            if (
                              !(typeof isSaveDisabled === "function"
                                ? isSaveDisabled()
                                : !!isSaveDisabled) &&
                              typeof handleSaveClick === "function"
                            ) {
                              console.log(
                                "Submitting registration after Zelle payment..."
                              );
                              handleSaveClick();
                            }
                          }}
                        >
                          Submit Registration
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : paymentMethod === "Stripe" && hasAmount ? (
                <div style={{ marginTop: "20px" }}>
                  <h5>Stripe Payment Instructions</h5>
                  <p>
                    Please proceed with Stripe payment for{" "}
                    <strong>
                      {(() => {
                        const stripeAmount = Number(
                          EventSupport.calculateAndApplyStripeFees(
                            amountNumber,
                            eventData
                          )
                        );
                        if (
                          !Number.isFinite(stripeAmount) ||
                          Number.isNaN(stripeAmount)
                        ) {
                          return "Unable to calculate the Stripe payment amount. Please contact support.";
                        }
                        return `$${stripeAmount.toFixed(2)}`;
                      })()}
                    </strong>
                  </p>
                  {/* Add Stripe payment component here */}
                  {eventData.stripe_URL && (
                    <div style={{ marginTop: "15px" }}>
                      <a
                        href={eventData.stripe_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        🔗 Click here to Pay with Stripe
                      </a>
                      Please click on "Submit Registration" button below and
                      make sure payment is completed within 2 weeks.
                    </div>
                  )}
                  <div style={{ marginTop: "15px" }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={
                        typeof isSaveDisabled === "function"
                          ? isSaveDisabled()
                          : !!isSaveDisabled
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          !(typeof isSaveDisabled === "function"
                            ? isSaveDisabled()
                            : !!isSaveDisabled) &&
                          typeof handleSaveClick === "function"
                        ) {
                          setGroupInfo((prev) => ({
                            ...prev,
                            status:
                              prev.status === "Draft" ? "New" : prev.status,
                          }));
                          console.log(
                            "Submitting registration after Stripe payment..."
                          );
                          handleSaveClick();
                        }
                      }}
                    >
                      Submit Registration
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          ) : (
            <div>
              {amountNumber <= 0 ? (
                <p>
                  Pending Amount must be greater than 0 to proceed with payment.
                </p>
              ) : groupInfo.status === "Wait List" ? (
                <>
                  <p
                    style={{
                      marginTop: "20px",
                      color: "orange",
                      fontWeight: "bold",
                    }}
                  >
                    Your Registration is in Wait List status. Payment can be
                    made once the registration is confirmed. Your Registration
                    ID is {groupInfo.registrationID}
                  </p>
                  {eventData?.contact && (
                    <div style={{ marginTop: "10px" }}>
                      {UtilMethods.formatTextWithLineBreaks(eventData.contact)}{" "}
                    </div>
                  )}
                  Email:{" "}
                  <a
                    href="mailto:retreat@graceanointing.org"
                    className="Contact"
                  >
                    retreat@graceanointing.org
                  </a>
                  <div style={{ marginTop: "15px" }}>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={
                        typeof isSaveDisabled === "function"
                          ? isSaveDisabled()
                          : !!isSaveDisabled
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          !(typeof isSaveDisabled === "function"
                            ? isSaveDisabled()
                            : !!isSaveDisabled) &&
                          typeof handleSaveClick === "function"
                        ) {
                          handleSaveClick();
                        }
                      }}
                    >
                      Submit Registration as Wait Listed
                    </button>
                  </div>
                </>
              ) : (
                <p>
                  Payment method is not PayPal or payment details are missing.
                </p>
              )}
            </div>
          )}
        </div>
        <div>
          {/* Success Modal */}
          <AlertModal
            show={showSuccessModal}
            title="Registration Successful %%%"
            message={
              "%%%%" +
              successMessage +
              " | Proceed to the Waiver Form, sign it and submit for you and your family members."
            }
            type="success"
            details={{}} // or pass additional details if necessary
            onCancel={handleCloseSuccessModal}
          />
          {/* Error Modal */}
          <AlertModal
            show={showErrorModal}
            title="Error in Retreat Registration"
            type="error"
            message={error}
            details={{}}
            onCancel={handleCloseModal}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default PaymentAccordion;
